import { Input } from '@civilgrid/ui/components';
import type React from 'react';
import { useState } from 'react';
import type { MapObject } from '~/common/types';
import { useCivilDrawStore } from '../../civilDrawStoreContext';

interface ObjTitleProps {
  currentObject: MapObject;
}

export default function ObjTitle({ currentObject }: ObjTitleProps) {
  const store = useCivilDrawStore();
  const [hasNoValue, setHasNoValue] = useState(false);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      setHasNoValue(true);
    } else {
      setHasNoValue(false);
    }

    store.updateObject({
      title: e.target.value,
    });
  };

  return (
    <div className="mt-2 flex items-center gap-2">
      {/* Icon will go here */}
      <Input
        name="object-title"
        aria-label="Object title"
        data-testid="civildraw-object-title"
        value={hasNoValue ? '' : currentObject.title}
        placeholder="Click to add title..."
        onChange={onChange}
      />
    </div>
  );
}
